import React, { useEffect, useState } from "react";
import { Route, Switch, withRouter, useHistory, useLocation } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { message } from "antd";
import "antd/es/message/style/index.css";
import PrivateRoute from "./route/PrivateRoute";
import { RedirectAs404 } from "./utils/Utils";

import Layout from "./layout/Index";
import ForgotPassword from "./pages/auth/ForgotPassword";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import SetPassword from "./pages/auth/SetPassword";
import Success from "./pages/auth/Success";

message.config({
  top: 80,
  duration: 4,
  maxCount: 3,
  prefixCls: "ant-message",
});

const antdMessageStyles = `
  .ant-message {
    z-index: 2000 !important;
  }
  .ant-message-notice {
    z-index: 2000 !important;
  }
`;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 1 minute
      staleTime: 1000 * 60,

      // 5 minutes
      cacheTime: 1000 * 60 * 5,

      retry: 1,
    },
  },
});

const App = () => {
  const [lastActivity, setLastActivity] = useState(Date.now());
  const navigate = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== "/auth-login") {
      const timeoutId = setTimeout(() => {
        const now = Date.now();
        const elapsedTime = now - lastActivity;
        const minutesSinceActivity = Math.floor(elapsedTime / (1000 * 60));
        if (minutesSinceActivity >= 60) {
          localStorage.clear();
          setLastActivity(now);
          navigate.push("/auth-login");
        }
      }, 1000 * 60); // Check every minute
      return () => clearTimeout(timeoutId);
    }
  }, [lastActivity, navigate, location.pathname]);

  const handleUserActivity = () => {
    setLastActivity(Date.now());
  };

  return (
    <QueryClientProvider client={queryClient}>
      <style>{antdMessageStyles}</style>
      <div onMouseMove={handleUserActivity} onClick={handleUserActivity} onKeyDown={handleUserActivity}>
        <Switch>
          <Route exact path={`${process.env.PUBLIC_URL}/auth-success`} component={Success} />
          <Route exact path={`${process.env.PUBLIC_URL}/auth-reset`} component={ForgotPassword} />
          <Route exact path={`${process.env.PUBLIC_URL}/auth-set`} component={SetPassword} />
          <Route exact path={`${process.env.PUBLIC_URL}/auth-register`} component={Register} />
          <Route exact path={`${process.env.PUBLIC_URL}/auth-login`} component={Login} />
          <PrivateRoute exact path="" component={Layout} />
          <Route component={RedirectAs404} />
        </Switch>
      </div>
    </QueryClientProvider>
  );
};

export default withRouter(App);

// import "antd/dist/antd.css";
// import React, { useEffect, useState } from "react";
// import { Route, Switch, withRouter, useHistory, useLocation } from "react-router-dom";
// import PrivateRoute from "./route/PrivateRoute";
// import { RedirectAs404 } from "./utils/Utils";

// import Layout from "./layout/Index";

// import ForgotPassword from "./pages/auth/ForgotPassword";
// import Login from "./pages/auth/Login";
// import Register from "./pages/auth/Register";
// import SetPassword from "./pages/auth/SetPassword";
// import Success from "./pages/auth/Success";

// const App = () => {
//   const [lastActivity, setLastActivity] = useState(Date.now());
//   const navigate = useHistory();
//   const location = useLocation();

//   useEffect(() => {
//     if(location.pathname !== "/auth-login") {
//       const intervalId = setInterval(() => {
//       const now = Date.now();
//       const elapsedTime = now - lastActivity;
//       const minutesSinceActivity = Math.floor(elapsedTime / (1000 * 60));

//       if (minutesSinceActivity >= 60) {
//           localStorage.clear();
//           setLastActivity(now);
//           navigate.push("/auth-login")
//         }
//       }, 1000);

//       return () => clearInterval(intervalId);
//     }
//   }, [lastActivity]);

//   const handleUserActivity = () => {
//     setLastActivity(Date.now());
//   };
//   return (
//     <div onMouseMove={handleUserActivity} onClick={handleUserActivity}>
//       <Switch>
//         {/* Auth Pages */}
//         <Route exact path={`${process.env.PUBLIC_URL}/auth-success`} component={Success} />
//         <Route exact path={`${process.env.PUBLIC_URL}/auth-reset`} component={ForgotPassword} />
//         <Route exact path={`${process.env.PUBLIC_URL}/auth-set`} component={SetPassword} />
//         <Route exact path={`${process.env.PUBLIC_URL}/auth-register`} component={Register} />
//         <Route exact path={`${process.env.PUBLIC_URL}/auth-login`} component={Login} />

//         {/*Main Routes*/}
//         <PrivateRoute exact path="" component={Layout} />
//         <Route component={RedirectAs404} />
//       </Switch>
//     </div>
//   );
// };
// export default withRouter(App);
